import { Button, Icon } from '@amzn/meridian';
import plusTokens from '@amzn/meridian-tokens/base/icon/plus';
import type { FC } from 'react';

type EmptyStateViewProps = {
  onUploadClick: () => void;
};

export const EmptyStateView: FC<EmptyStateViewProps> = ({ onUploadClick }) => (
  <Button onClick={onUploadClick}>
    <Icon tokens={plusTokens} /> Add media
  </Button>
);
